import { API } from '@aws-amplify/api'
import { useMutation, UseMutationResult } from 'react-query'
import * as Sentry from '@sentry/nextjs'

type SubmitHome = {
  address: string
  email: string
}

const submitHome = async ({
  address,
  email,
}: SubmitHome): Promise<SubmitHome> => {
  try {
    const res = await API.post('listing', '/submit_home', {
      body: {
        homeAddress: address,
        emailAddress: email,
      },
    })

    return res
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  } catch (error: any) {
    Sentry.captureException(error)
    throw new Error(error.response?.data?.message || 'Something went wrong')
  }
}

export const useSubmitHome = (): UseMutationResult<
  SubmitHome,
  Error,
  SubmitHome,
  unknown
> => {
  return useMutation('submitHome', (data: SubmitHome) => submitHome(data))
}
